import { keyMirror } from "../../../utils";

export default keyMirror([
  'INIT_FORM',
  'DESTROY_FORM',
  'ON_FORM_CHANGE',
  'ADD_ARES_FIELD',
  'REMOVE_ARES_FIELD',
  'MAKE_FIELD_DIRTY',
  'CLEAN_FIELD_DIRTY',
  'MAKE_ALL_FIELDS_DIRTY',
  'HIGHLIGHT_ERRORS',
  'HIGHLIGHT_CURRENT_FIELD',
  'ADD_CONSTRAINT',
  'REMOVE_CONSTRAINT',
  'DROP_VALIDATION',
  'GET_SELECT_VALUE',
  'FETCH_FIELD_OPTIONS',
  'PROMISE_POST_TAG',
  'CLEAR_FORM_VALUES',

  'REMOVE_ASSOC_ITEM',
  'FETCH_ARES_VALUES',
  'ADD_NEW_CONTACT',

  'FETCH_AUTHORITIES',
  'FETCH_ITEMS_BY_NODES',
  'FETCH_OPTIONS',
  'FETCH_OPTIONS_ASYNC',
  'FETCH_VALUE_BY_NODES',

  'ON_FORM_SUBMIT_PROMISE',

  'REARRANGE_ASSOC_ITEMS',

  'FETCH_INIT_DATA_BOX',
  'FETCH_DATA_BOX',

  'TRANSITION_SUBMIT',

  'TOGGLE_TABLE_MODAL',
  'TOGGLE_TABLE_FORM_MODAL',
  'PROMISE_UPLOAD_PACKAGE_ITEMS',
  'PROMISE_UPLOAD_ATTACHMENT',
  'FETCH_ITEMS_BY_NODES_FOR_TABLE',

  'CALC_NEXT_DATE',
]);
